import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-products" }
const _hoisted_2 = { class: "container" }

import imageAlt from '@/components/web/imageAlt.vue';
import { onBeforeMount, ref, reactive } from 'vue'

type imgItem = {
    imgUrl: string;
    text: string;
}



export default /*@__PURE__*/_defineComponent({
  __name: 'viewHomeService',
  props: {
    honorCertificatesCollection: {},
    dieCastingWorkshopCollection: {},
    productCollection: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h5", null, "Other Die Casting Parts And Machining Products", -1)),
      _createVNode(imageAlt, {
        "image-alt-collection": _ctx.productCollection,
        "has-tail-hr": false
      }, null, 8, ["image-alt-collection"])
    ])
  ]))
}
}

})